import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { api, awardPoints } from "../lib/api";

export default function BlogDetail() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/content/blogs/${id}`).then((r) => setBlog(r.data)).catch(() => setNotFound(true));
    awardPoints("read_blog", id);
  }, [id]);

  if (notFound) return (
    <div className="pt-40 pb-32 text-center">
      <h1 className="font-display font-800 uppercase text-5xl">Article not found</h1>
      <Link to="/blog" className="text-primary mt-4 inline-block uppercase text-xs tracking-widest font-bold">Back to Journal</Link>
    </div>
  );
  if (!blog) return <div className="pt-40 pb-32 text-center text-muted-foreground">Loading…</div>;

  return (
    <article data-testid="blog-detail-page" className="pt-28">
      <div className="mx-auto max-w-3xl px-5">
        <Link to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-muted-foreground hover:text-primary transition-colors mb-7"><ArrowLeft size={14} /> Journal</Link>
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.15em] font-bold">
          <span className="text-primary">{blog.tag}</span>
          <span className="flex items-center gap-1 text-muted-foreground"><Clock size={12} /> {blog.read_time}</span>
        </div>
        <h1 className="font-display font-900 uppercase text-4xl sm:text-5xl md:text-6xl leading-[0.92] tracking-tight mt-3">{blog.title}</h1>
      </div>
      <div className="mx-auto max-w-5xl px-5 my-10">
        <div className="aspect-[16/8] overflow-hidden rounded-lg border border-border"><img src={blog.image} alt={blog.title} className="w-full h-full object-cover" /></div>
      </div>
      <div className="mx-auto max-w-3xl px-5 pb-24">
        {(blog.body || "").split("\n\n").map((p, i) => (<p key={i} className="text-lg leading-relaxed text-muted-foreground mb-6">{p}</p>))}
        <div className="mt-10 border-t border-border pt-10 text-center">
          <p className="font-display font-800 uppercase text-3xl">Want a plan built for you?</p>
          <Link to="/assessment" className="inline-block mt-5 bg-primary text-primary-foreground px-8 py-4 rounded-full text-xs uppercase tracking-[0.15em] font-bold hover:scale-[1.03] transition-transform">Take Free Assessment</Link>
        </div>
      </div>
    </article>
  );
}
